import { Department } from "../models/department.model";

export class User {
     public username: string;
     public email: string;
     public password: string;
     public id: number;
     public hospitalId: number; 
     public active: boolean;
     public departments: Department[] = [];
     public role: string;
     public isCurrentUser: boolean;  
}